import React, {useEffect, useState} from 'react';
import {useFieldArray, useForm} from "react-hook-form";
import moment from "moment";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import { v4 as uuidv4 } from 'uuid';
import DayItem from "./DayItem";
import DaysWrapper from "./DaysWrapper";
import {Form, Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import _ from "lodash";
import DatePicker from "react-datepicker";
import axios from "../../../helpers/axios";
import {useParams} from "react-router-dom";
import {ModalFooter} from "reactstrap";



export const itemTempValues = {
  name: '',
  text:'',
  checked: false,
  id : uuidv4()
}
const dayTempValues = {
  date: moment().format('DD.MM.YYYY'),
  items:[itemTempValues]
}
const TripCheckForm = ({data, cb, firstLoad, setFirstLoad}) => {
  const [baseData,setBaseData] = useState(data)
  const [show, setShow]= useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setBaseData(data)
  }, [data]);

  useEffect(() => {
    if(firstLoad){
      setFirstLoad(false)
    }else{
      cb(baseData)
    }
  }, [baseData]);

  const addDay = (date) =>{
    setBaseData(prevData => {
      const copied = structuredClone(prevData.days)
      copied.push({
        date: moment(date).format('DD.MM.YYYY'),
        items:[{...itemTempValues, columns: moment(date).format('DD.MM.YYYY')}]
      })
      return {...prevData, days: _.sortBy(copied, d => moment(d.date, 'DD.MM.YYYY').unix())}
    })
    setShow(!show)
  }


  return (
    <div>
      <div className={'d-flex align-items-center gap-2 mb-3'}>
        <div style={{position: 'relative', width: '100%'}}>
          <label className={'absolutLabel'}>Наименование чек-листа</label>
          <Form.Control
            name={'search'}
            defaultValue={baseData.name}
            onFocus={(e)=>{
              if(e.target.value === 'Ваше название'){
                e.target.select()
              }
            }}
            onBlur={(e) => setBaseData(q => ({...q, name: e.target.value}))}
            className={'form-control'}
            type={'text'}
            placeholder="Услуга"
          />
        </div>
        <Button variant={'outline-secondary'}
                onClick={()=>setShow(!show)}>
          <i className="fa fa-plus ml-2"/>
        </Button>
      </div>
      <DndProvider backend={HTML5Backend}>
        {baseData.days.map((day, index) => {
          return <DaysWrapper key={index} day={day} setBaseData={setBaseData}>
            {day.items.map((item, i) => {
              return <DayItem itemD={item}
                              currentColumnName={day.date}
                              index={i}
                              key={i}
                              setBaseData={setBaseData}/>

            })}
          </DaysWrapper>
        })}
      </DndProvider>
      <Modal show={show} size={'sm'} onHide={()=>setShow(!show)}>
        <Modal.Header closeButton>
          <Modal.Title>Выберите дату</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DatePicker
            selected={baseData.days.length > 0? moment(baseData.days[baseData.days.length-1]?.date, 'DD.MM.YYYY').add(1, 'day').toDate(): moment().toDate()}
            autoComplete='off'
            className={"form-control"}
            dateFormat={'dd.MM.yyyy'}
            locale={'ru'}
            calendarStartDay={1}
            onChange={addDay}
          />
          <Modal.Footer>
            <Button onClick={()=>
              addDay(baseData.days.length > 0?moment(baseData.days[baseData.days.length-1]?.date, 'DD.MM.YYYY').add(1, 'day').toDate(): moment().toDate())
            }>
              Добавить
            </Button>
          </Modal.Footer>

        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TripCheckForm;



